module.exports = __webpack_public_path__ + "img/filed-work-tree.2d757e60.png";